__turbopack_context__.v({
  "className": "volkhov_67ad3cab-module__trKa_q__className",
});
